import { deleteData, getDataWithQuery, postData } from '../api';
import { API_END_POINT } from '../constants/ApiEndPointConstant';

export const getAllReport = (data: {
  query: string;
  pageNumber: number;
  pageSize: number;
  type?: 'USER' | 'FILE' | 'MESSAGE'
}) => {
  return getDataWithQuery(API_END_POINT.report.getAll, data);
};

export const getReportById = (id: string | number) => {
    return getDataWithQuery(API_END_POINT.report.getById, { id });
  };
  
  export const saveReport = (data: any) => {
    return postData(API_END_POINT.report.save, data);
  };
  
  export const deleteReport = (id: string | number) => {
    return deleteData(API_END_POINT.report.delete, id);
  };

  export const reportContent = (id: number | string, isReport: boolean) => {
    return postData(API_END_POINT.report.reportContent+ `?id=${id}&isReport=${isReport}`,{id, isReport} );
};